export const buildHomePageUrl = (lang: string) => {
  const sub = lang === 'en' ? 'www' : lang;
  return `https://${sub}.wix.com`;
};

export const buildViewerUrl = (lang: string, templateId: string) =>
  `${buildHomePageUrl(lang)}/website-template/view/html/${templateId}`;

export const buildStudioTemplatesUrl = (lang: string) => `${buildHomePageUrl(lang)}/studio/templates`;

export const buildWebsiteTemplatesUrl = (lang: string) => `${buildHomePageUrl(lang)}/website/templates`;

const STUDIO_CATEGORY_SLUG_PREFIX = 'studio-';
const resolveCategorySlug = (slug: string) => {
  if (slug.startsWith(STUDIO_CATEGORY_SLUG_PREFIX)) {
    return slug.slice(STUDIO_CATEGORY_SLUG_PREFIX.length);
  }

  return slug;
};

export const buildCategoryUrl = (baseUrl: string, categorySlugs: string[]) =>
  `${baseUrl}/html/${categorySlugs.map(resolveCategorySlug).join('/')}`;

export const buildMicroCategoryUrl = (baseUrl: string, microCategorySlug: string) =>
  `${baseUrl}/refine/${resolveCategorySlug(microCategorySlug)}`;

const EXPERIMENTS_OFF_QUERY = 'experimentsoff=specs.thunderbolt.viewport_hydration_extended_react_18';

const appendQueryParam = (url: string, param: string) => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${param}`;
};

export const buildIframeUrl = (publicUrl: string, options?: { showMobileView?: boolean }) => {
  let updatedUrl = publicUrl.startsWith('https://') ? publicUrl : `https://www.wix.com/${publicUrl}`;
  if (options?.showMobileView) {
    updatedUrl = appendQueryParam(updatedUrl, 'showMobileView=true');
  }

  return appendQueryParam(updatedUrl, EXPERIMENTS_OFF_QUERY);
};
